/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_OptionAwardListDto } from '../models/PagedResultDto_OptionAwardListDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class OptionAwardListV2Service {

    /**
     * @param approvalStatusIds 
     * @param createdFromDate 
     * @param createdToDate 
     * @param grantFromDate 
     * @param grantToDate 
     * @param employeeStatuses 
     * @param optionStatus 
     * @param optionAcceptance 
     * @param isEarlyExercisable 
     * @param approvedFromDate 
     * @param approvedToDate 
     * @param publishFromDate 
     * @param publishToDate 
     * @param expirationFromDate 
     * @param expirationToDate 
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_OptionAwardListDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppOptionAwardListV2OptionAwardListAsyncV2(
approvalStatusIds?: Array<number>,
createdFromDate?: string,
createdToDate?: string,
grantFromDate?: string,
grantToDate?: string,
employeeStatuses?: Array<number>,
optionStatus?: number,
optionAcceptance?: number,
isEarlyExercisable?: boolean,
approvedFromDate?: string,
approvedToDate?: string,
publishFromDate?: string,
publishToDate?: string,
expirationFromDate?: string,
expirationToDate?: string,
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_OptionAwardListDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/option-award-list-v2/option-award-list-async-v2',
            query: {
                'ApprovalStatusIds': approvalStatusIds,
                'CreatedFromDate': createdFromDate,
                'CreatedToDate': createdToDate,
                'GrantFromDate': grantFromDate,
                'GrantToDate': grantToDate,
                'EmployeeStatuses': employeeStatuses,
                'OptionStatus': optionStatus,
                'OptionAcceptance': optionAcceptance,
                'IsEarlyExercisable': isEarlyExercisable,
                'ApprovedFromDate': approvedFromDate,
                'ApprovedToDate': approvedToDate,
                'PublishFromDate': publishFromDate,
                'PublishToDate': publishToDate,
                'ExpirationFromDate': expirationFromDate,
                'ExpirationToDate': expirationToDate,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
